export function round(value: number, places: number): number {
  return +(Math.round(Number(value + 'e+' + places)) + 'e-' + places);
}

export function roundOdds(value: number): number {
  switch (true) {
    case value < 1.01: {
      return round(value, 3);
    }
    case value < 10: {
      return round(value, 2);
    }
    case value < 20: {
      return round(value, 1);
    }
    default: {
      return Math.ceil(value);
    }
  }
}

type ReturnType = [number | string | null, number | string | null, number | string | null];

export const getOddText = ({
  oddDecimal,
  oddFractional,
  oddsFormat,
  prevOddDecimal,
  prevOddFractional,
}: {
  oddDecimal: number;
  oddFractional: string;
  oddsFormat: string;
  prevOddDecimal: number;
  prevOddFractional: string;
}): ReturnType => {
  const defaultOddText = 'SP';
  const oddDec = oddDecimal ? roundOdds(oddDecimal) : defaultOddText;
  const prevOddDec = prevOddDecimal ? roundOdds(prevOddDecimal) : '';
  const validPrevOdd = !!prevOddDec && oddDec !== defaultOddText && prevOddDec < oddDec;

  const percentage =
    validPrevOdd && typeof oddDec === 'number' && typeof prevOddDec === 'number'
      ? ((oddDec - prevOddDec) / prevOddDec) * 100
      : null;

  const roundedPercentage = percentage && +(Math.round(Number(percentage + 'e+' + 0)) + 'e-' + 0);

  if (oddsFormat === 'decimal') {
    if (!validPrevOdd) {
      return [oddDec, '', roundedPercentage];
    }

    return [oddDec, prevOddDec, roundedPercentage];
  }

  const oddFrac = oddFractional ? oddFractional : defaultOddText;
  const prevOddFrac = prevOddFractional ? prevOddFractional : '';

  if (!validPrevOdd) {
    return [oddFrac, '', roundedPercentage];
  }

  return [oddFrac, prevOddFrac, roundedPercentage];
};
